import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { CashFlowApi } from '../cashFlow.api';

export const useGetCashToSupplierCalculation = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: CashFlowApi.getCashToSupplierCalculation,
  });
};
